import { useState } from 'react';
import { Checkbox, Input, Tooltip } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { IFilterOption } from '@common-types';
import { isEmpty } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

interface IProps {
  title?: string;
  titleInformation?: string;
  options: IFilterOption[] | undefined;
  values: string[];
  onChange: (selectedValues: any[]) => void;
  disabled?: boolean;
  withShowMore?: boolean;
  displayZero?: boolean;
  inputFilter?: boolean;
  excludeBorder?: boolean;
  hideCount?: boolean;
}

const zero = 0;
const defaultOptionsCount = 5;

export function FilterBox(props: IProps) {
  const {
    displayZero,
    title,
    titleInformation,
    options,
    values,
    onChange,
    disabled = false,
    withShowMore = false,
    inputFilter,
    excludeBorder = false,
    hideCount = false,
  } = props;

  const [shownMore, setShownMore] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const intl = useIntl();

  const showShowMore = withShowMore && (options?.length || 0) > defaultOptionsCount && !disabled;
  const resOptions = showShowMore
    ? shownMore
      ? options
      : options?.slice(zero, defaultOptionsCount)
    : options;

  const style: React.CSSProperties = {};
  if (inputFilter) {
    style.paddingBottom = '10px';
  }

  let resOptionsFiltered = resOptions;
  if (inputFilter && !isEmpty(inputValue)) {
    resOptionsFiltered = resOptions?.filter(o => o.label?.toString().toLowerCase().includes(inputValue));
  }

  return (
    <div className={`filter filter-checkbox ${excludeBorder ? 'exclude-border' : ''}`}>
      {!isEmpty(title) ? (
        <p className="filter__title secondary-font" style={style}>
          <FormattedMessage id={title} />
          {!isEmpty(titleInformation) ? (
            <Tooltip title={intl.formatMessage({ id: titleInformation })} placement="top">
              <FontAwesomeIcon icon={faInfoCircle} />
            </Tooltip>
          ) : null}
        </p>
      ) : null}

      {inputFilter && (
        <div style={{ paddingBottom: '20px', position: 'relative' }}>
          <Input value={inputValue} onChange={e => setInputValue(e.target.value)} />
          {!isEmpty(inputValue) && (
            <span style={{ position: 'absolute', right: '5px', top: '2px', padding: '5px', cursor: 'pointer' }} onClick={() => setInputValue('')}>
              <FontAwesomeIcon icon={faTimesCircle} />
            </span>
          )}
        </div>
      )}

      <Checkbox.Group value={values} onChange={onChange} disabled={disabled} className="filter-box__group">
        {resOptionsFiltered?.map((item: IFilterOption) => {
          if (!item.count && !displayZero) {
            return null;
          }

          const count = item.count ? item.count : 0;

          return (
            <Checkbox
              key={item.value}
              value={item.value}
              disabled={disabled || item?.disabled}
              className="filter-box__option-box"
            >
              <span className="filter-box__option-content">
                <span className="filter-box__option-label">
                  <Tooltip title={item.label}>{(item.label?.toString().length || 0) > 20 ? item.label?.toString().substring(0, 20) + '...' : item.label}</Tooltip>
                  {!hideCount && (count > zero || (displayZero && count === zero)) && (
                    <span className="filter-box__option-count">({count > zero ? item.count : count})</span>)}
                </span>
              </span>
            </Checkbox>
          );
        })}
      </Checkbox.Group>

      {showShowMore ? (
        <div className="filter__show-link" onClick={() => setShownMore(prev => !prev)}>
          {shownMore ? <FormattedMessage id="show.less" /> : <FormattedMessage id="show.more" />}
        </div>
      ) : null}
    </div>
  );
}
